import React, {
  useState,
  useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Page from '../../../components/Layout/Page';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import DeveloperDimensionEditForm from './DeveloperDimensionEditForm';
import Header from './Header';
import developerDimensionRequest from '../../../requests/api/developer_dimension';
import useStyles from './styles';

function DeveloperDimensionEditView(props) {
  const classes = useStyles();
  const isMountedRef = useIsMountedRef();
  const [developerDimension, setDeveloperDimension] = useState();

  useEffect(() => {
    const getDeveloperDimension = async () => {
      const res = await developerDimensionRequest.getDeveloperDimensionById(props.match.params.id);
      const response = res.data;
      if (isMountedRef.current) {
        setDeveloperDimension(response.data.developer_dimension);
      }
    };

    getDeveloperDimension();
    // eslint-disable-next-line
  }, [props]);

  if (!developerDimension) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Editar Talento"
    >
      <Container maxWidth="lg">
        <Header />
        <Box mt={3}>
          <DeveloperDimensionEditForm developerDimension={developerDimension}/>
        </Box>
      </Container>
    </Page>
  );
}

DeveloperDimensionEditView.propTypes = {
  match: PropTypes.any,
};

export default withRouter(DeveloperDimensionEditView);
